<template>
  <div class="tab-table">
    <table-actions>
      <button v-if="inline && addButton" @click="addNew">Создать</button>
      <router-link v-else-if="addButton" :to="{ name: `${this.category}-new` }" tag="button">Создать</router-link>
      <slot name="actions"/>
    </table-actions>
    <table-element
      v-bind="tableOpt"
      :actions="inline"
      v-on:changeOrder="changeOrder"
      v-on:rowClick="rowClick"
    >
      <template v-if="!inline" #city="{ value }">{{ value.title }}</template>
      <template v-if="!inline" #status="{ value }">{{ value.title }}</template>
      <template #type="{ value }">{{ value.title }}</template>
      <template #created_at="{ value }">{{ formatDate(value) }}</template>
      <template #maintenance_date="{ value }">{{ formatDate(value) }}</template>
      <template #image_url="{ value }">
        <div class="table-image">
          <img :src="value">
        </div>
      </template>
      <template v-if="!inline" #phones="{ value }">{{ value ? value.join(',') : '' }}</template>
      <template v-if="!inline" #address="{ value }">{{ value ? value.join(',') : '' }}</template>
      <template v-if="inline" #title="{ value, row }">
        <template v-if="editingRowId === row.id">
          <div class="flex-row">
            <input
              type="text"
              v-model="editingValue"
              placeholder="Заполните поле"
              @click.stop
              @keyup.enter="saveRow(row.id)"
              ref="input"
            >
            <button @click.stop="toggleEditing(row.id)">Отмена</button>
            <button v-if="row.id" class="red" @click.stop="removeRow(row.id)">Удалить</button>
          </div>
        </template>
        <template v-else>
          <span>{{ value }}</span>
        </template>
      </template>
      <template v-if="inline" #url="{ value, row }">
        <template v-if="editingRowId === row.id">
          <div class="flex-row">
            <input
              type="text"
              v-model="editingValue"
              placeholder="Заполните поле"
              @click.stop
              @keyup.enter="saveRow(row.id)"
              ref="input"
            >
            <button @click.stop="toggleEditing(row.id)">Отмена</button>
            <button v-if="row.id" class="red" @click.stop="removeRow(row.id)">Удалить</button>
          </div>
        </template>
        <template v-else>
          <span>{{ value }}</span>
        </template>
      </template>
      <template v-if="inline" #actions="{ row, value }">
        <template v-if="editingRowId === row.id">
          <button :disabled="!saveable" @click.stop="saveRow(row.id)">✓</button>
        </template>
        <template v-else>
          <button @click.stop="toggleEditing(row.id)">✎</button>
        </template>
      </template>
    </table-element>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';
import TableActions from '@/components/common/TableActions';

import Moment from 'moment';

export default {
  name: 'simple-table',

  components: {
    TableElement,
    TableActions,
  },

  props: {
    inline: {
      type: Boolean,
      default: false,
    },

    addButton: {
      type: Boolean,
      default: true,
    },

    inlineField: {
      type: String,
      default: 'title',
    },

    category: {
      type: String,
      required: true,
    },

    columns: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      required: true,
    },

    list: {
      type: Array,
      required: true,
    },

    error: {
      // eslint-disable-next-line
      type: Error | Object,
    },
  },

  data() {
    return {
      editingRowId: false,
      editingValue: null,
      order: {},
      prependList: [],
    };
  },

  computed: {
    saveable() {
      return !!this.editingValue;
    },

    tableOpt() {
      return {
        list: [...this.prependList, ...this.list],

        order: this.order,

        loading: this.loading,

        error: this.error,

        columns: this.columns,
      };
    },
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch(...params) {
      this.$emit('fetch', ...params);
    },

    create(...params) {
      this.$emit('create', ...params);
    },

    save(...params) {
      this.$emit('save', ...params);
    },

    remove(...params) {
      this.$emit('remove', ...params);
    },

    formatDate(date) {
      return Moment(date).format('llll');
    },

    changeOrder(column) {
      const order = this.order.column === column ? !this.order.desc : false;

      this.order = {
        column: column,
        desc: order,
      };

      this.fetch(); // TODO: добавить параметры сортировки и фильтрации
    },

    rowClick(id) {
      this.$emit('rowClick', id);
      if (this.inline) {
        const row = this.list.find(row => row.id === id);

        this.toggleEditing(row.id);
      }
    },

    addNew() {
      const newItem = {
        id: null,
      };
      this.prependList = [];
      this.prependList.push(newItem);
      this.editingValue = null;
      this.editingRowId = null;
      this.focusOnInput();
    },

    saveRow(rowId) {
      if (this.saveable) {
        if (rowId) {
          this.save(rowId, this.editingValue);
        } else {
          this.create(this.editingValue);
        }
        this.closeEditing();
      } else {
        this.$snotify.warning('Необходимо заполнить поле', null, {
          showProgressBar: false,
        });
      }
    },

    removeRow(rowId) {
      this.remove(rowId);
      this.closeEditing();
    },

    toggleEditing(rowId) {
      const row = this.list.find(row => row.id === rowId);
      const value = row ? row[this.inlineField] : null;

      this.prependList = [];

      if (this.editingRowId === rowId) {
        this.editingRowId = null;
        this.editingValue = null;
      } else {
        this.editingRowId = rowId;
        this.editingValue = value;
        this.focusOnInput();
      }
    },

    closeEditing() {
      this.prependList = [];
      this.editingRowId = null;
      this.editingValue = null;
    },

    focusOnInput() {
      this.$nextTick(() => this.$refs.input.focus());
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;

  input,
  button {
    height: 30px;
  }

  .flex-row {
    display: flex;

    > * {
      margin-right: 8px;
    }
  }

  .table-image {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 40px;
      padding: 4px;
      background: #aaa;
    }
  }
}
</style>
